//photos you import here, separate by comma
import {
  Image_01,
  Image_02,
  Image_03,
  Image_04,
  Image_05,
  Image_06,
  Image_07,
  insta
} from '../assets'

//videos imported here, separated by comma
import {
  Video_01,
  Video_02,
  Video_03,
  Video_04,
  Video_05,
  Video_06,
  Video_07
} from '../assets'

//each project is separated by a bracket and comma
const projects = [
    {
      id: "1",
      password: "",
      hasPassword: false,
      company: "Harley",
      poster: Image_01,
      source: Video_01,
    },
    {
      id: "2",
      password: "",
      hasPassword: false,
      company: "Stray",
      poster: Image_02,
      source: Video_02,
    },
    {
      id: "3",
      password: "",
      hasPassword: false,
      company: "Xfinity",
      poster: Image_03,
      source: Video_03,
    },
    {
      id: "4",
      password: "",
      hasPassword: false,
      company: "Cox Con",
      poster: Image_04,
      source: Video_04,
    },
    {
      id: "5",
      password: "",
      hasPassword: false,
      company: "Ubrelvy",
      poster: Image_05,
      source: Video_05,
    },
    {
      id: "6",
      password: "",
      hasPassword: false,
      company: "Dentek",
      poster: Image_06,
      source: Video_06,
    },
    {
      id: "7",
      password: "",
      hasPassword: false,
      company: "CoxBiz",
      poster: Image_07,
      source: Video_07,
    }
];

export default projects